module.exports = __webpack_public_path__ + "img/129.8da9148d.jpg";